export const service = {
  data: [{
    title: '家政保洁服务',
    location: '北京市朝阳区',
    public: '李先生',
    mobile: '18601139746',
    fee: '50元/小时'
  }, {
    title: '家电维修服务',
    location: '上海市黄浦区',
    public: '王女士',
    mobile: '13918720397',
    fee: '100元/次'
  }, {
    title: '搬家服务',
    location: '广州市越秀区',
    public: '赵先生',
    mobile: '15802798375',
    fee: '300元/车次'
  }, {
    title: '空调清洗服务',
    location: '深圳市南山区',
    public: '张小姐',
    mobile: '13611029184',
    fee: '150元/台'
  }, {
    title: '电脑维修服务',
    location: '成都市锦江区',
    public: '刘先生',
    mobile: '13729013746',
    fee: '80元/次'
  }, {
    title: '宠物寄养服务',
    location: '杭州市西湖区',
    public: '孙女士',
    mobile: '13529750191',
    fee: '100元/天'
  }, {
    title: '家庭水电维修',
    location: '南京市鼓楼区',
    public: '周先生',
    mobile: '15973900825',
    fee: '200元/次'
  }, {
    title: '房屋粉刷服务',
    location: '重庆市渝北区',
    public: '吴女士',
    mobile: '13882630129',
    fee: '30元/平方米'
  }, {
    title: '上门按摩服务',
    location: '武汉市武昌区',
    public: '何先生',
    mobile: '13775329828',
    fee: '200元/小时'
  }, {
    title: '园艺养护服务',
    location: '天津市河西区',
    public: '韩小姐',
    mobile: '18601387295',
    fee: '150元/次'
  }, {
    title: '家居搬运服务',
    location: '苏州市姑苏区',
    public: '陈先生',
    mobile: '13597632859',
    fee: '250元/车次'
  }, {
    title: '家庭厨师服务',
    location: '重庆市南岸区',
    public: '杨女士',
    mobile: '13985372386',
    fee: '300元/餐'
  }]
}